export default "__VITE_ASSET__Bd72EKa7__"